import { Tooltip } from '@nextui-org/react';
import { useState } from 'react';

const CustomCircleIconButton = ({
  onClick,
  Icon,                    // Lucide icon component to render
  tooltipContent = 'Button tooltip',
  iconSize = 18,           // Default size for the icon
  iconStrokeWidth = 1,     // Default stroke width for the icon
  buttonPadding = '10px',  // Controls the button size/padding
  customStyle = {},         // Additional styles to override the default styling
  marginLeft = '0px',      // Margin left for the button
  marginRight = '0px',     // Margin right for the button
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const iconButtonStyle = {
    backgroundColor: isHovered ? '#292a30' : '#23242b',
    border: 'none',
    padding: buttonPadding,
    borderRadius: '90px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
    boxShadow: isHovered
      ? '0px 4px 6px rgba(0, 0, 0, 0.5)'
      : '0px 2px 3px rgba(0, 0, 0, 0.3)',
    ...customStyle,
    marginLeft: marginLeft,
    marginRight: marginRight,
  };

  return (
    <Tooltip delay={1000} content={tooltipContent}>
      <button
        style={iconButtonStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick}
      >
        {Icon && <Icon size={iconSize} strokeWidth={iconStrokeWidth} />}
      </button>
    </Tooltip>
  );
};

export default CustomCircleIconButton;
